import {createSelector} from 'reselect'

const stateReducer = state => state.dataReducer;

export const selectFetching = (initData) =>
    createSelector(
        stateReducer,
        dataReducer => dataReducer.isFetching
    )

export const selectStatusAction = (initData) =>
    createSelector(
        stateReducer,
        dataReducer => dataReducer.statusAction
    )

export const selectMasterDataLeadType = (initItems) =>
    createSelector(
        stateReducer,
        dataReducer => dataReducer.masterLeadType
    )


export const selectMasterDataOtherLeadType = (initItems) =>
    createSelector(
        stateReducer,
        dataReducer => dataReducer.masterOtherLeadType
    )

export const selectUploadDataOtherLeadType = (initItems) =>
    createSelector(
        stateReducer,
        dataReducer => dataReducer.uploadOtherLeadTypes
    )
